import React from "react";
import SideModal from "components/SideModal";
import SelectInput from "components/SelectInput";
import { useFormattedMessage } from "hooks";
import NewLoader from "components/NewLoader";

const messages = {
    approve: "approve",
    reject: "reject",
};

const WrappedFilterSideModal = ({
    open,
    onCloseButtonClick,
    isShowActions = false,
    loading,
    statusUmbrellaClearance,
    selectedStatusUmbrellaClearance,
    setSelectedStatusUmbrellaClearance,
    isApproving,
    isRejecting,
    onRejectBtnClicked = () => {},
    disabledActionBtn,
    onConfirm = () => {},
}) => {
    const { formatMessage } = useFormattedMessage();

    return (
        <SideModal
            className="admin-filter-modal"
            open={open}
            onCloseButtonClick={() => onCloseButtonClick()}
            containerClassName="mw-100"
            heading={isShowActions ? "Actions" : "Filter"}
        >
            <div className="filter-options">
                {isShowActions ? (
                    <>
                        <button
                            disabled={loading || isApproving || disabledActionBtn}
                            className={`text-16 mb-4 secondary ${loading || disabledActionBtn ? "disable-grey" : ""}`}
                            onClick={() => onConfirm()}
                        >
                            {isApproving ? <NewLoader /> : formatMessage(messages.approve)}
                        </button>
                        <button
                            disabled={loading || isApproving || disabledActionBtn}
                            onClick={onRejectBtnClicked}
                            className={`text-16 mb-4 secondary ${loading || disabledActionBtn ? "disable-grey" : ""}`}
                        >
                            {isRejecting ? <NewLoader /> : formatMessage(messages.reject)}
                        </button>
                    </>
                ) : (
                    <>
                        <SelectInput
                            className="mb-3 w-100 filter-select"
                            name="status_kyc"
                            options={statusUmbrellaClearance}
                            placeholder="Status"
                            value={selectedStatusUmbrellaClearance}
                            isSearchable={false}
                            isClearable
                            selectClassName="small-menu-list"
                            onChange={(value) => setSelectedStatusUmbrellaClearance(value)}
                        />
                    </>
                )}
            </div>
        </SideModal>
    );
};

export default WrappedFilterSideModal;
